export default {
    namespaced: true,
    state: {
        notifications: {
            query: '',
            options: '{"page":1,"itemsPerPage":10,"sortBy":["created"],"sortDesc":["created"]}',
            filters: '{}'
        },
        applications: {
            query: '',
            options: '{"page":1,"itemsPerPage":10,"sortBy":["created"],"sortDesc":["created"]}',
            filters: '{}'
        }
    },
    getters: {
        notifications: (state) => {
            const search = state.notifications
            return {
                query: search.query,
                options: JSON.parse(search.options),
                filters: JSON.parse(search.filters)
            }
        },
        applications: (state) => {
            const search = state.applications
            return {
                query: search.query,
                options: JSON.parse(search.options),
                filters: JSON.parse(search.filters)
            }
        }
    },
    actions: {
        save({commit}, payload) {
            const component = payload.component
            const searchParams = {
                query: payload.params.query,
                options: JSON.stringify(payload.params.options),
                filters: JSON.stringify(payload.params.filters)
            }
            switch (component) {
                case 'notifications':
                    commit('SET_NOTIFICATIONS', searchParams)
                    break
                case 'applications':
                    commit('SET_APPLICATIONS', searchParams)
                    break
            }
        },
        reset({commit}, component) {
            switch (component) {
                case 'notifications':
                    commit('RESET_NOTIFICATIONS')
                    break
                case 'applications':
                    commit('RESET_APPLICATIONS')
                    break
            }
        }
    },
    mutations: {
        'SET_NOTIFICATIONS': (state, payload) => {
            state.notifications = payload
        },
        'SET_APPLICATIONS': (state, payload) => {
            state.applications = payload
        }
    }
}